import React from 'react';
import SimpleBalloon from "./SimpleBalloon";

const PlanCardBulk = ({
  title,
  description,
  price,
  discountedPrice,
  minLessons,
  period,
  consultant,
  makeupLessons,
  feature,
  isSingle, // カードが1つだけの場合に適用するためのプロップ
  isCampaignPeriod,
}) => {
  return (
    <article className={`plan-card ${isSingle ? 'single-card' : ''}`}>
      <header className="plan-header">
        <h2 className="plan-title">{title}</h2>
      </header>
      <div className="plan-detail">
        <p className="plan-description" dangerouslySetInnerHTML={{ __html: description }} />
        <div className="price-container">
          {isCampaignPeriod ? (
            // キャンペーン期間中の料金表示
            <div>
              <div className="price-wrapper original-price">
                <div className="price-group">
                  <span className="price-label">総額</span>
                  <span className="price strikethrough">{price}</span>
                  <span className="price-currency">円~</span>
                </div>
              </div>
              <SimpleBalloon text="期間限定" />
              <div className="price-wrapper discount-price">
                <span className="price-label">総額</span>
                <span className="price">{discountedPrice}</span>
                <span className="price-currency">円~</span>
              </div>
            </div>
          ) : (
            // 通常の料金表示
            <div className="price-wrapper">
              <span className="price-label">総額</span>
              <span className="price">{price}</span>
              <span className="price-currency">円~</span>
            </div>
          )}
        </div>
        <div className="plan-details">
          {minLessons && (
            <div className="plan-detail-item">
              <span className="label">最小購入レッスン数:</span>
              <span className="value">{minLessons}</span>
            </div>
          )}
          {makeupLessons && (
            <div className="plan-detail-item">
              <span className="label">振替上限数:</span>
              <span className="value">{makeupLessons}</span>
            </div>
          )}
        </div>
        <p className="plan-feature">{feature}</p>
      </div>
    </article>
  );
};

export default PlanCardBulk;

